module.exports = __webpack_public_path__ + "img/sch2-info.b93adecd.png";